"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./components/ResizeGroup/index"), exports);
//# sourceMappingURL=ResizeGroup.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/ResizeGroup.js
// module id = ../node_modules/office-ui-fabric-react/lib/ResizeGroup.js
// module chunks = 1